import {loadCompany} from '../company/actions'
import {DEFAULT_TODO_QUERY, loadTodoStream} from './actions'
import TodoLayout from './components/TodoLayout'
import TodoStreamLayout from './components/TodoStreamLayout'

export function todoRoute(rootPath, dispatcher, {getState}) {

    function enterTodoStream(dispatch) {
        const state = getState()
        const {authenticated} = state.user
        const {criteria} = state.workflow.todo

        return Promise.all([
            dispatch(loadTodoStream({...DEFAULT_TODO_QUERY, ...criteria})),
            authenticated.company && dispatch(loadCompany(authenticated.company.uid))
        ])
    }

    return {
        path: rootPath,
        component: TodoLayout,
        indexRoute: {
            component: TodoStreamLayout,
            onEnter: dispatcher(enterTodoStream)
        }
    }
}


// WEBPACK FOOTER //
// ./lib/workflow/routes.js